"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    content: {
        padding: theme.spacing(1, 2)
    },
    iconButton: {
        padding: '5px'
    },
    resetIcon: {
        fontSize: 12
    }
}));
const PopoverFilter = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const { children, isActive, onReset } = props;
    const handleReset = () => {
        onReset();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { onClick: handleClick, style: { color: isActive ? '#000' : '#ccc' }, className: classes.iconButton },
            react_1.default.createElement(FilterList_1.default, null)),
        isActive && (react_1.default.createElement(core_1.IconButton, { onClick: handleReset, className: classes.iconButton, "data-testid": "reset-button" },
            react_1.default.createElement(Close_1.default, { className: classes.resetIcon }))),
        react_1.default.createElement(core_1.Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            } },
            react_1.default.createElement("div", { className: classes.content }, children))));
};
exports.default = PopoverFilter;
